import styled from '@emotion/styled';

const First:React.FC<any> = () => {
  return (
    <Container>
      <BodyImgContainer className="first">
        <Img src="/images/newLanding/product/0G0A9758.png"/>
      </BodyImgContainer>
      <Text1>
        가족이 함께하는 <br/>시간을 따뜻하게 해주니까요
      </Text1>
    </Container>
  )
}

export default First;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;


const Img = styled.img`
  width: 100%;
`;

const BodyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  &.second{
    padding: 40px 0;
    background-color: #f0Ede7;
  }
`

const BodyImgContainer = styled.div`
  &.first{
    width: 100%;
  }

  &.second {
    width: 90%;
    margin: 0 auto;
    
  }
    
`
const Text1 = styled.div`
  font-size: 18px;
  display: flex;
  margin: 40px auto 80px;
  font-weight: 600;
  text-align: center;
`;

const SmallText = styled.div`
  font-size: 14px;
  margin: 30px auto 100px;
  text-align: center;
`;

const Text2 = styled.div`
  font-size: 20px;
  display: flex;
  margin: 40px auto 0px;

  span {
    font-weight: 600;
  }
`;